export interface DaysHoursMinutes {
  days: number
  hours: number
  minutes: number
}

export interface APIExecutionStepsType {
  isLoading: boolean
  isFetching: boolean
  isUninitialized: boolean
  isSuccess: boolean
  isError: boolean
}

export interface ProductCardSummary {
  completedActivitiesCount: number
  totalActivitiesCount: number
  completedLevelsCount: number
  totalLevelsCount: number
}

export interface MathEssentialProductCardSummary {
  totalCorrectInBestAttempts: number
  totalInCorrectInBestAttempts: number
  progressPercentage: number
}

export enum DayOfMonth {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
}

export enum MathTopicsType {
  ALGEBRA = 'algebra',
  GEOMETRY = 'geometry',
  NUMBER_AND_QUANTITIES = 'numbers-and-quantities',
  FUNCTIONS = 'functions',
  STATISTICS_AND_PROBABILITY = 'statistics-and-probability',
  PROOF = 'proof',
}
